import React from "react";
const membersList = [
  {
    id: 1,
    picture: "/assets/images/drShakibi.jpg",
    name: "دکتر محمدرضا شکیبی",
    career: "متخصص داخلی، فوق تخصص روماتولوژی",
  },
  {
    id: 2,
    name: "دکتر علی اصغر هنرمند",
    picture: "/assets/images/drHonarmand.jpg",
    career: "پزشک عمومی",
  },
];
const Members = () => {
  return (
    <section className="max-w-5xl mx-auto p-6">
      <div className="flex flex-col">
        <h2 className=" font-semibold text-lg team-border p-6 w-fit items-center mx-auto mb-8 ">
          معرفی تیم کلینیک لانجویتی
        </h2>
        <ul className="flex gap-10 justify-evenly max-md:flex-col items-center">
          {membersList.map((member) => (
            <li
              key={member.id}
              className="flex flex-col gap-4 w-1/3 max-md:w-full items-center "
            >
              <img
                src={member.picture}
                className=" rounded-full w-full max-md:w-1/2 "
                alt="member team"
              />
              <span className=" font-bold text-sm text-nowrap">
                {member.name}
              </span>
              <span className=" font-bold text-sm text-gray-500 text-nowrap">
                {member.career}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Members;
